import { Component, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { LandingService } from '../landing.service';

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.scss'],
  animations: [
    trigger('home', [
      // ...
      state('enlarged', style({
        width: '90vw',
        height: '90vh'
      })),
      transition ('* => enlarged', [
        // style({width : '*'}),
        animate ('1s ease'),
      ]),
      transition ('enlarged => *', [
        animate ('1s ease',
        ),
      ]),
    ]),
  ],
})
export class AboutPageComponent implements OnInit {

  @ViewChildren('homeItem') homeItems: QueryList<ElementRef>;

  content = [
    { link: '../../assets/images/final2.png', enlarged: false },
    { link: '../../assets/images/IMG_9167 copy.jpg', enlarged: false },
    { link: '../../assets/images/61031261_293797678239116_6914847181341982720_n (1).png', enlarged: false },
    { link: '../../assets/images/unta4itdled.png', enlarged: false },
  ]

  constructor(public landingService: LandingService) { }

  ngOnInit() {
    this.landingService.showLogo();
    this.landingService.updateLocation('About');
    setTimeout(() => {console.log(this.homeItems)},3000)
  }

  enlarge(item){
    item.enlarged =! item.enlarged
  }

}
